// extracted by mini-css-extract-plugin
export default {"container":"UserMatchContainer_container__Itten","matchContainer":"UserMatchContainer_matchContainer__Su9kV","animateOpacity":"UserMatchContainer_animateOpacity__-8C0-"};